import { MappedEnrichedEvent } from 'services/api/entities/events/types/internal/event-models'
import { TimeLabel } from 'services/utils/date'
import {
  yupArray,
  yupDate,
  yupIgnore,
  yupNumber,
  yupObject,
  YupSchema,
  yupString,
} from 'services/yup'
import { EventProductStatus, EventStatus, ProfessionalOutfit } from 'types/form'
import { customizationVS } from './customization'
import { mainProductSelectionVS } from './selections/common/mainProduct'
import { drinkSelectionVS } from './selections/drinks'
import { foodSelectionVS } from './selections/foods'
import { locationSelectionVS } from './selections/locations'
import { physicalExperienceSelectionVS } from './selections/physicals'
import { virtualExperienceSelectionVS } from './selections/virtuals'
import { eventGeneralServiceVS } from './services/generalService'
import { enrichedProductServicesBundleVS } from './services/productService'
import { enrichedProfessionalServiceVS } from './services/professionalService'

export const eventVS: YupSchema<MappedEnrichedEvent> = yupObject().shape({
  id: yupIgnore(),
  name: yupIgnore(),
  fullAddress: yupString(),
  guestsNumber: yupNumber().required().min(1),
  startDate: yupDate().required(),
  endDate: yupDate().required(),
  briefStatus: yupIgnore(),
  coupon: yupIgnore(),
  createdAt: yupIgnore(),
  storeUpdatedAt: yupIgnore(),
  customer: yupNumber().required(),
  customerInfo: yupObject(),
  customerDocs: yupArray().optional(),
  kampaayerDocs: yupArray().optional(),
  drinkNotes: yupString(),
  foodNotes: yupString(),
  virtualExperiencesNotes: yupString(),
  physicalExperienceNotes: yupString(),
  rentNotes: yupString(),
  musicNotes: yupString(),
  locationNotes: yupString(),
  purchasedServicesArray: yupArray().optional(),
  eventStatus: yupString<EventStatus>().required(),
  drinkStatus: yupString<EventProductStatus>(),
  foodStatus: yupString<EventProductStatus>(),
  rentStatus: yupString<EventProductStatus>(),
  musicStatus: yupString<EventProductStatus>(),
  locationStatus: yupString<EventProductStatus>(),
  professionalStatus: yupString<EventProductStatus>(),
  physicalExperienceStatus: yupString<EventProductStatus>(),
  virtualExperiencesStatus: yupString<EventProductStatus>(),
  professionalOutfit: yupString<ProfessionalOutfit>().optional(),
  purchasedServices: yupIgnore(),
  paymentStatus: yupIgnore(),
  supplierStatus: yupIgnore(),
  supplierMessagesStatus: yupIgnore(),
  customizations: yupArray(customizationVS),
  drinks: yupArray(drinkSelectionVS),
  rents: yupArray(mainProductSelectionVS),
  musics: yupArray(mainProductSelectionVS),
  locations: yupArray(locationSelectionVS),
  virtuals: yupArray(virtualExperienceSelectionVS),
  physicals: yupArray(physicalExperienceSelectionVS),
  foods: yupArray(foodSelectionVS),
  professionals: yupArray(enrichedProfessionalServiceVS),
  generalService: eventGeneralServiceVS.optional(),
  productServices: enrichedProductServicesBundleVS,
  surveyResponses: yupArray(),
  musicDeliveryTime: yupString<TimeLabel>(),
  rentDeliveryTime: yupString<TimeLabel>(),
  musicPickupDate: yupDate().optional(),
  rentPickupDate: yupDate().optional(),
})
